import {
  CascadiaCustomIcon,
  CascadiaIcon,
  CascadiaMiniIcon,
  CascadiaStandardIcon,
  customIcons,
  miniIcons,
  standardIcons,
} from "@certn/cascadia-tokens";

export function getIcon(
  type: "standard" | "mini" | "custom",
  name: CascadiaIcon
) {
  switch (type) {
    case "mini":
      return miniIcons[name as CascadiaMiniIcon];
    case "custom":
      return customIcons[name as CascadiaCustomIcon];
    case "standard":
      return standardIcons[name as CascadiaStandardIcon];
  }
}
